//!!! DO NOT EDIT THIS FILE, IT IS AUTO-GENERATED !!!//

import { APICall } from './APICall';
import { APIOutput } from './APIOutput';
import { Await } from './Await';
import { Classifier } from './Classifier';
import { ECMASandbox } from './ECMASandbox';
import { FTimestamp } from './FTimestamp';
import { GenAILLM } from './GenAILLM';
import { HuggingFace } from './HuggingFace';
import { ImageGenerator } from './ImageGenerator';
import { MCPClient } from './MCPClient';
import { ScrapflyWebScrape } from './ScrapflyWebScrape';
import { ServerlessCode } from './ServerlessCode';
import { TavilyWebSearch } from './TavilyWebSearch';



const Components = { APICall, APIOutput, Await, Classifier, ECMASandbox, FTimestamp, GenAILLM, HuggingFace, ImageGenerator, MCPClient, ScrapflyWebScrape, ServerlessCode, TavilyWebSearch, };
 export default Components; 